module.exports = __webpack_public_path__ + "static/img/recorder-icon-large.37a5e416.jpg";